import React, { FC } from 'react';
import MuiRadioGroup, { RadioGroupProps as MuiRadioGroupProps } from '@mui/material/RadioGroup';
import { BpDesignSystem } from '../../types';

export type RadioGroupProps = BpDesignSystem.PropsWithChildren<MuiRadioGroupProps & {}>;

export const RadioGroup: FC<RadioGroupProps> = ({ dataTest, ...props }) => (
  <MuiRadioGroup data-test={dataTest} {...props} />
);
